import Icon from '../components/Elements/Icons/Icon'
import Warning from '../components/Elements/Warning'
import SwitchDayButtons from '../components/Forms/Elements/SwitchDayButtons'

export default [
  Icon,
  SwitchDayButtons,
  Warning
]
